import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { pt } from "date-fns/locale";
import { startOfToday } from "date-fns";
import { Calendar } from "@/components/ui/calendar";

export const Availability = ({ bookedMatchers = [] }) => {
  const [months, setMonths] = useState(2);

  useEffect(() => {
    const update = () => setMonths(window.innerWidth < 768 ? 1 : 2);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <section id="disponibilidade" data-testid="availability-section" className="overflow-x-hidden bg-sand py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.3fr] lg:items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-4 text-xs font-medium uppercase tracking-[0.3em] text-clay">Disponibilidade</p>
          <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl">
            Dias livres e <em className="text-clay">ocupados</em>.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-fog">
            Os dias a riscado já estão reservados ou com pedido pendente. Os restantes estão disponíveis — escolha as suas datas no pedido de reserva.
          </p>
          <div className="mt-8 flex flex-wrap gap-5 text-sm text-fog" data-testid="availability-legend">
            <span className="flex items-center gap-2"><span className="h-3.5 w-3.5 rounded-full bg-white ring-1 ring-ink/20" /> Livre</span>
            <span className="flex items-center gap-2"><span className="h-3.5 w-3.5 rounded-full bg-ink/15 ring-1 ring-ink/10" /> Ocupado</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="flex min-w-0 justify-center rounded-3xl border border-line bg-white p-3 shadow-[0_24px_60px_-30px_rgba(28,27,26,0.3)] sm:p-6"
          data-testid="availability-calendar"
        >
          <Calendar
            locale={pt}
            numberOfMonths={months}
            fromMonth={startOfToday()}
            disabled={[{ before: startOfToday() }, ...bookedMatchers]}
            modifiers={{ booked: bookedMatchers }}
            modifiersClassNames={{ booked: "day-booked" }}
            classNames={{
              months: "flex flex-col gap-8 sm:flex-row sm:gap-10",
              caption_label: "font-display text-base capitalize text-ink",
              head_cell: "w-9 sm:w-10 text-[11px] font-medium uppercase tracking-wider text-fog",
              cell: "p-0.5 text-center text-sm",
              day: "h-9 w-9 sm:h-10 sm:w-10 rounded-full text-sm text-ink cursor-default hover:bg-transparent",
              day_today: "font-bold text-clay",
              day_disabled: "text-fog/40",
              day_outside: "text-fog/30",
            }}
          />
        </motion.div>
      </div>
    </section>
  );
};
